// Do not change these - they are set in the monolith
export const INSURANCE_CARRIER_KEY = 'insuranceCarrier';
export const INSURANCE_PLAN_KEY = 'insurancePlan';
